import React from "react";
import "./strategyNavigation.css";

export default function ClientParticipationSummary({ count, onManage }) {
  return <div className="client-participation-summary"><span>Participating clients: <strong>{count}</strong></span><div className="client-participation-actions">{onManage && <button type="button" onClick={onManage}>Manage in Client Accounts</button>}</div></div>;
}
